var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full white border"},[_c('CompareHouseholdDetails',{attrs:{"one":_vm.one,"two":_vm.two,"surveyID":_vm.surveyID}}),_c('CompareHouseholdMembers',{attrs:{"one":_vm.one,"two":_vm.two}}),_c('CompareHouseholdButtons',{attrs:{"one":_vm.one,"two":_vm.two,"surveyID":_vm.surveyID}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }